export default "__VITE_ASSET__uw8kUiCQ__"